define('header',['controller', 'session'], function(controller, session) {
	// update return_url of login box in header on navigation
	controller.onNavigation(function() {
		var url = location.pathname + location.search;
		$('#header-login-box input[name=login_return_url]').val(url);
		// delete any POST-preserving related elements
		// that means, after navigation, POST data should no longer be preserved
		$('#header-login-box input[type=hidden]:not([name=login_return_url])').remove();
	});
	
	function scrollFixed() {
		var elems = $('#header, #footer, #chat-info-box, .chat-form'); // TODO generalize
		if ($('body').hasClass('fixed')) {
			if ($(window).width() < $('#header').width()) {
				var lefts = [];
				elems.css('position', 'static'); 
				elems.each(function() {
					lefts.push($(this).offset().left); // works only correctly if not fixed
				});
				elems.css('position', '');
				var scrollOffset = $(window).scrollLeft();
				for (i = 0; i < elems.length; i++) {
					$(elems[i]).css('left', lefts[i] - scrollOffset);
				}
			} else
				elems.css('left', '');
		} else
			elems.css('left', '');
	}
	
	session.on('change', function() {
		// just let the header load at next navigation when logged in
		controller.disableAjaxLoading();
	});
	
	var isFixed = false;
	function enableFixed() {
		isFixed = true;
		$(window).on('scroll', scrollFixed);
		$(window).on('scroll', scrollFixed);
	}
		
	function disableFixed() {
		isFixed = false;
		scrollFixed();
		$(window).off('scroll', scrollFixed);
		$(window).off('scroll', scrollFixed);
	}
	
	if ($('body').hasClass('fixed'))
		enableFixed();
	
	$('body').on('class-change', function() {
		if (isFixed && !$('body').hasClass('fixed'))
			disableFixed();
		else if (!isFixed && $('body').hasClass('fixed'))
			enableFixed();
	});
	
	$('.load-conversations').click(function() {
		//show spinner	
		$('#header-message-menu').find('.spinner').show();
		$('#message-box-content').html('');
		
		//TODO: here's a bug when you close the box via the message icon
		
		$.getJSON('/account/load_message_box', function(data) {
			//show box content
			$('#header-message-menu').find('.spinner').hide();
			$('#message-box-content').html(data.html);
		});
	});
	
	$('.load-notifications').click(function() {
		//show spinner	
		$('#header-notifications-menu').find('.spinner').show();
		$('#notification-box-content').html('');

		//TODO: here's a bug when you close the box via the message icon
		loadNotificationBox();
	});

	function loadNotificationBox() {
		$.getJSON('/account/load_notification_box', function(data) {
			//show box content
			$('#header-notifications-menu').find('.spinner').hide();
			$('#notification-box-content').html(data.html);
		});
	}
	
	$('#search-extend-icon').click(function(e){
		e.preventDefault();
		var searchInput = $('#search-extendable .search-query');
		
		if(searchInput.hasClass('open') && searchInput.val()) {
		} else {
			searchInput.focus();
		}
	});

	return {
		loadNotificationBox: loadNotificationBox
	};
});

